export default __webpack_public_path__ + "static/media/logoAtoutFrance.4950486f.png";